














































































































































































































































































































































































































import Vue from 'vue'
import FeaturedProject from '@/components/FeaturedProject.vue'
import FooterItem from '@/components/FooterItem.vue'
const carousel = require('v-owl-carousel')

export default Vue.extend({
  name: 'home',
  components: {
    FeaturedProject,
    FooterItem,
    carousel
  },
  data: function () {
    return {
      projects: [
        {
          name: 'Lorem ipsum dolor sit 1',
          img: {
            src: 'assets/img/project-1.png',
            alt: 'texto alt'
          },
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.'
        },
        {
          name: 'Lorem ipsum dolor sit 2',
          img: {
            src: 'assets/img/project-2.png',
            alt: 'texto alt'
          },
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.'
        },
        {
          name: 'Lorem ipsum dolor sit 3',
          img: {
            src: 'assets/img/project-3.png',
            alt: 'texto alt'
          },
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.'
        },
        {
          name: 'Lorem ipsum dolor sit 4',
          img: {},
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.'
        }
      ]
    }
  }
})
